import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export function InlineSetItem({ children, className }) {
  return <div className={cx('item', className)}>{children}</div>;
}

InlineSetItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

const SPACING_SIZE_LARGE = 'large';
const spacingSizeClasses = {
  [SPACING_SIZE_LARGE]: 'doubleSpacing',
};

/**
 * Automatically wraps all the components with InlineSetItem,
 * to provide inline-block container as well as indent between
 */
export default function InlineSet({
  children,
  spacingSize,
  isColumn,
  className,
  childrenClassName,
}) {
  return (
    <div
      className={cx('container', spacingSizeClasses[spacingSize], { column: isColumn }, className)}
    >
      {React.Children.map(children, (child, key) =>
        child ?
          <InlineSetItem className={childrenClassName} key={+key}>
            {child}
          </InlineSetItem>
        : null,
      )}
    </div>
  );
}

InlineSet.propTypes = {
  children: PropTypes.node,
  isColumn: PropTypes.bool,
  spacingSize: PropTypes.oneOf([SPACING_SIZE_LARGE]),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  childrenClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};
